var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesignCommunityBro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 282.18,
    y: 150.3,
    width: 13.58,
    height: 13,
    style: {
      fill: "#F8FF35"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.62,119.06s1.23-8.61-3.89-14.14-16.6-1.23-19.26,3.49.21,10.85,1.23,11.88,1.23,2,0,4.09-1.64,2.26-.41,2.87a10.74,10.74,0,0,0,2,.82s3.69,4.51,4.71,6.15a3.12,3.12,0,0,0,4.3,1c1.23-.82,7-5.94,7-5.94l8.6,3.48a21,21,0,0,0,0-6.76C359.31,122.54,358.28,119.06,355.62,119.06Z",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.62,315c-1.34,4.28-3.34,1.09-4.51-16.3-.54-8.16-1.35-24.84,8-21.92,8.94,2.8-.42,28.34-.42,28.34Zm12.57,1.43s17.14-21.11,9.59-26.67C100.93,284,96.27,300,94.14,307.89c-4.54,16.83-3.69,20.5-1,16.88Zm5.41,17.23s16.17-13.66,11.2-19c-5.17-5.56-11,6-13.82,11.75-5.91,12.21-5.79,15.14-3.24,12.76Zm6.1,17.11s16.17-13.66,11.21-19c-5.17-5.55-11.06,6-13.83,11.76-5.91,12.21-5.79,15.13-3.23,12.75ZM77.77,318.06s-25.08-10.53-28.29-1.72c-3.33,9.16,13.37,9.12,21.54,9,17.42-.37,20.7-2.22,16.48-3.75Zm4.53,13.49s-26.67-5.32-28.06,3.94c-1.45,9.65,14.91,6.29,22.88,4.5,17-3.83,19.85-6.3,15.41-7Zm7.21,14.53s-22.68-3.89-23.64,4c-1,8.19,12.75,5,19.45,3.27,14.3-3.63,16.64-5.78,12.88-6.24ZM94,358.19s-22.14-6.27-23.94,1.45c-1.86,8,12.16,6.3,19,5.32,14.6-2.1,17.16-4,13.46-4.84ZM74.43,296.56s-12.33-29.65-23-23.19c-11.1,6.72,3.42,19.35,10.66,25.37C77.53,311.59,82,312.2,79.75,307.46Z",
    style: {
      fill: "#F8FF35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.62,315c-1.34,4.28-3.34,1.09-4.51-16.3-.54-8.16-1.35-24.84,8-21.92,8.94,2.8-.42,28.34-.42,28.34Zm12.57,1.43s17.14-21.11,9.59-26.67C100.93,284,96.27,300,94.14,307.89c-4.54,16.83-3.69,20.5-1,16.88Zm5.41,17.23s16.17-13.66,11.2-19c-5.17-5.56-11,6-13.82,11.75-5.91,12.21-5.79,15.14-3.24,12.76Zm6.1,17.11s16.17-13.66,11.21-19c-5.17-5.55-11.06,6-13.83,11.76-5.91,12.21-5.79,15.13-3.23,12.75ZM77.77,318.06s-25.08-10.53-28.29-1.72c-3.33,9.16,13.37,9.12,21.54,9,17.42-.37,20.7-2.22,16.48-3.75Zm4.53,13.49s-26.67-5.32-28.06,3.94c-1.45,9.65,14.91,6.29,22.88,4.5,17-3.83,19.85-6.3,15.41-7Zm7.21,14.53s-22.68-3.89-23.64,4c-1,8.19,12.75,5,19.45,3.27,14.3-3.63,16.64-5.78,12.88-6.24ZM94,358.19s-22.14-6.27-23.94,1.45c-1.86,8,12.16,6.3,19,5.32,14.6-2.1,17.16-4,13.46-4.84ZM74.43,296.56s-12.33-29.65-23-23.19c-11.1,6.72,3.42,19.35,10.66,25.37C77.53,311.59,82,312.2,79.75,307.46Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,283.84s27.11,28,34.25,42.54c8.2,16.71,14.35,36.24,16.6,52.28",
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.52,
    y1: 316.98,
    x2: 86.57,
    y2: 288.05,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.24,
    y1: 326.38,
    x2: 101.62,
    y2: 301.28,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89.13,
    y1: 322.96,
    x2: 62.76,
    y2: 319.83,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.24,
    y1: 339.64,
    x2: 111.05,
    y2: 321,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94.64,
    y1: 334.09,
    x2: 75.04,
    y2: 335.54,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99.59,
    y1: 347.99,
    x2: 84.62,
    y2: 349.83,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103.42,
    y1: 356.81,
    x2: 110.58,
    y2: 345.42,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.34,
    y1: 360.75,
    x2: 86.71,
    y2: 361.33,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.78,230.22c-5,2.71-4-2,10.38-18.82,6.74-7.91,20.82-23.79,26.7-12.88,5.64,10.49-25.55,25.41-25.55,25.41Zm10.15,12.47s34.35-4,32.42-15.73c-2-12.24-20.49-1.78-29.44,3.5-19.08,11.27-21.55,15.36-15.93,14.43Zm-10.37,20.47s26.84,1.94,27.06-7.33c.23-9.64-15.41-4.33-23-1.58-16.22,5.85-18.71,8.62-14.27,8.72Zm-9.65,21s26.84,1.94,27.06-7.33c.24-9.64-15.41-4.33-23-1.59-16.22,5.86-18.71,8.63-14.27,8.73Zm-.91-59s-13.47-31.85-24.21-26.69c-11.17,5.37,4,20.17,11.64,27.26,16.18,15.14,20.8,16.37,18.32,11.24Zm-7.87,16.29s-19.53-28.53-29-21.34c-9.88,7.49,8,19,16.82,24.41,18.87,11.62,23.65,11.91,20.2,7.36Zm-6.34,19.62s-17.18-23.68-25-17.38c-8.19,6.56,7.18,15.85,14.79,20.25,16.22,9.4,20.26,9.53,17.24,5.77Zm-6.66,15s-14.57-25.37-23.06-19.94c-8.83,5.65,5.47,16.52,12.56,21.71,15.13,11.06,19.14,11.62,16.54,7.56Zm36.92-73.45s15.11-37.92-.32-41.52c-16.07-3.75-14.08,20.63-12.84,32.54,2.64,25.4,6.18,30,8.31,23.61Z",
    style: {
      fill: "#F8FF35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.78,230.22c-5,2.71-4-2,10.38-18.82,6.74-7.91,20.82-23.79,26.7-12.88,5.64,10.49-25.55,25.41-25.55,25.41Zm10.15,12.47s34.35-4,32.42-15.73c-2-12.24-20.49-1.78-29.44,3.5-19.08,11.27-21.55,15.36-15.93,14.43Zm-10.37,20.47s26.84,1.94,27.06-7.33c.23-9.64-15.41-4.33-23-1.58-16.22,5.85-18.71,8.62-14.27,8.72Zm-9.65,21s26.84,1.94,27.06-7.33c.24-9.64-15.41-4.33-23-1.59-16.22,5.86-18.71,8.63-14.27,8.73Zm-.91-59s-13.47-31.85-24.21-26.69c-11.17,5.37,4,20.17,11.64,27.26,16.18,15.14,20.8,16.37,18.32,11.24Zm-7.87,16.29s-19.53-28.53-29-21.34c-9.88,7.49,8,19,16.82,24.41,18.87,11.62,23.65,11.91,20.2,7.36Zm-6.34,19.62s-17.18-23.68-25-17.38c-8.19,6.56,7.18,15.85,14.79,20.25,16.22,9.4,20.26,9.53,17.24,5.77Zm-6.66,15s-14.57-25.37-23.06-19.94c-8.83,5.65,5.47,16.52,12.56,21.71,15.13,11.06,19.14,11.62,16.54,7.56Zm36.92-73.45s15.11-37.92-.32-41.52c-16.07-3.75-14.08,20.63-12.84,32.54,2.64,25.4,6.18,30,8.31,23.61Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.48,175.58s-.2,49.54-6.63,69.11c-7.38,22.49-19.13,45.71-31.33,62.3",
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422,
    y1: 231.07,
    x2: 448.65,
    y2: 205.69,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 418.85,
    y1: 244.69,
    x2: 450.59,
    y2: 231.09,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 419.97,
    y1: 239.71,
    x2: 398.76,
    y2: 213.44,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 412.54,
    y1: 262.08,
    x2: 441.65,
    y2: 257.39,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 415.1,
    y1: 254.73,
    x2: 395.98,
    y2: 238.65,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 407.25,
    y1: 271.77,
    x2: 392,
    y2: 260.15,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 402.91,
    y1: 283.19,
    x2: 419.53,
    y2: 279.19,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 400.25,
    y1: 287.59,
    x2: 383.69,
    y2: 272.46,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.27,214.62c-1.88,2.87-2.68.1.13-12.92,1.31-6.11,4.22-18.53,10.45-14.43,6,3.94-6.27,20.73-6.27,20.73Zm8.94,3.7s17-11.91,12.66-17.57c-4.56-5.9-11.35,4.9-14.58,10.25-6.87,11.41-7,14.28-4.31,12.18Zm.35,13.8s14.76-6.64,12.23-11.6c-2.63-5.18-9.39,2.1-12.63,5.72-6.91,7.73-7.44,9.9-5.06,8.69Zm.88,13.86s14.76-6.64,12.23-11.61c-2.63-5.17-9.39,2.11-12.63,5.73-6.91,7.73-7.44,9.9-5.06,8.69Zm-17.31-31s-16.22-13-20.43-7.21c-4.38,6,7.9,9.52,13.94,11.11,12.88,3.39,15.68,2.72,12.9.71Zm.49,10.87s-18.48-9.52-21.45-3c-3.1,6.78,9.63,7.75,15.86,8.11,13.3.77,15.91-.45,12.79-1.87Zm2.24,12.19s-15.85-7.62-18.21-2c-2.46,5.8,8.32,6.33,13.6,6.49,11.27.34,13.45-.74,10.78-1.87Zm.76,9.85s-15-9.26-17.89-4c-3.06,5.51,7.61,7.18,12.84,7.9,11.16,1.54,13.45.69,10.91-.72Zm-1.43-49.4s-2.82-24.38-12-21.88c-9.58,2.6-1.56,14.93,2.49,20.88,8.64,12.69,11.82,14.09,11.14,10.13Z",
    style: {
      fill: "#F8FF35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.27,214.62c-1.88,2.87-2.68.1.13-12.92,1.31-6.11,4.22-18.53,10.45-14.43,6,3.94-6.27,20.73-6.27,20.73Zm8.94,3.7s17-11.91,12.66-17.57c-4.56-5.9-11.35,4.9-14.58,10.25-6.87,11.41-7,14.28-4.31,12.18Zm.35,13.8s14.76-6.64,12.23-11.6c-2.63-5.18-9.39,2.1-12.63,5.72-6.91,7.73-7.44,9.9-5.06,8.69Zm.88,13.86s14.76-6.64,12.23-11.61c-2.63-5.17-9.39,2.11-12.63,5.73-6.91,7.73-7.44,9.9-5.06,8.69Zm-17.31-31s-16.22-13-20.43-7.21c-4.38,6,7.9,9.52,13.94,11.11,12.88,3.39,15.68,2.72,12.9.71Zm.49,10.87s-18.48-9.52-21.45-3c-3.1,6.78,9.63,7.75,15.86,8.11,13.3.77,15.91-.45,12.79-1.87Zm2.24,12.19s-15.85-7.62-18.21-2c-2.46,5.8,8.32,6.33,13.6,6.49,11.27.34,13.45-.74,10.78-1.87Zm.76,9.85s-15-9.26-17.89-4c-3.06,5.51,7.61,7.18,12.84,7.9,11.16,1.54,13.45.69,10.91-.72Zm-1.43-49.4s-2.82-24.38-12-21.88c-9.58,2.6-1.56,14.93,2.49,20.88,8.64,12.69,11.82,14.09,11.14,10.13Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.06,185.51s14,26.27,16.21,38.46c2.51,14,2.92,29.65,1.2,41.91",
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 272.05,
    y1: 215.86,
    x2: 278.9,
    y2: 194.83,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 274.27,
    y1: 223.97,
    x2: 287.18,
    y2: 207.71,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.44,
    y1: 221.02,
    x2: 254.72,
    y2: 213.17,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 275.89,
    y1: 234.98,
    x2: 289.96,
    y2: 224.19,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 275.15,
    y1: 230.35,
    x2: 260.44,
    y2: 227.3,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 275.86,
    y1: 241.61,
    x2: 264.47,
    y2: 239.81,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.82,
    y1: 248.9,
    x2: 284.47,
    y2: 242.03,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.67,
    y1: 251.98,
    x2: 263.59,
    y2: 248.7,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.93,390.47c1.31,2.44-1,1.94-9.14-5.08-3.83-3.29-11.53-10.15-6.22-13,5.11-2.73,12.32,12.45,12.32,12.45ZM83,385.55s-1.88-16.71-7.6-15.78c-6,1-.89,10,1.66,14.31,5.45,9.29,7.44,10.5,7,7.76Zm9.94,5.07s1-13.05-3.53-13.17c-4.68-.12-2.12,7.49-.8,11.19,2.82,7.89,4.17,9.1,4.22,6.94Zm10.19,4.72s1-13-3.53-13.17c-4.69-.12-2.12,7.49-.8,11.19,2.82,7.89,4.16,9.1,4.22,6.94Zm-28.67.36s-15.5,6.5-13,11.73c2.59,5.44,9.81-1.95,13.27-5.62,7.38-7.84,8-10.09,5.48-8.89Zm7.91,3.84S68.47,409,72,413.62c3.63,4.82,9.23-3.85,11.89-8.14,5.68-9.15,5.82-11.47,3.61-9.8Zm9.52,3.12S80.36,411,83.41,414.8c3.18,4,7.71-3.47,9.86-7.16,4.59-7.87,4.66-9.84,2.83-8.37Zm7.29,3.25s-12.35,7-9.72,11.18c2.73,4.31,8-2.63,10.57-6.07,5.4-7.34,5.67-9.29,3.7-8Zm-35.65-18s-18.41-7.41-20.18.09c-1.85,7.81,10,6.87,15.8,6.29,12.35-1.25,14.57-3,11.49-4Z",
    style: {
      fill: "#F8FF35"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.93,390.47c1.31,2.44-1,1.94-9.14-5.08-3.83-3.29-11.53-10.15-6.22-13,5.11-2.73,12.32,12.45,12.32,12.45ZM83,385.55s-1.88-16.71-7.6-15.78c-6,1-.89,10,1.66,14.31,5.45,9.29,7.44,10.5,7,7.76Zm9.94,5.07s1-13.05-3.53-13.17c-4.68-.12-2.12,7.49-.8,11.19,2.82,7.89,4.17,9.1,4.22,6.94Zm10.19,4.72s1-13-3.53-13.17c-4.69-.12-2.12,7.49-.8,11.19,2.82,7.89,4.16,9.1,4.22,6.94Zm-28.67.36s-15.5,6.5-13,11.73c2.59,5.44,9.81-1.95,13.27-5.62,7.38-7.84,8-10.09,5.48-8.89Zm7.91,3.84S68.47,409,72,413.62c3.63,4.82,9.23-3.85,11.89-8.14,5.68-9.15,5.82-11.47,3.61-9.8Zm9.52,3.12S80.36,411,83.41,414.8c3.18,4,7.71-3.47,9.86-7.16,4.59-7.87,4.66-9.84,2.83-8.37Zm7.29,3.25s-12.35,7-9.72,11.18c2.73,4.31,8-2.63,10.57-6.07,5.4-7.34,5.67-9.29,3.7-8Zm-35.65-18s-18.41-7.41-20.18.09c-1.85,7.81,10,6.87,15.8,6.29,12.35-1.25,14.57-3,11.49-4Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.37,390.05s24.08.16,33.58,3.32a113.82,113.82,0,0,1,30.24,15.31",
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.33,
    y1: 391.81,
    x2: 65.03,
    y2: 378.83,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83.95,
    y1: 393.37,
    x2: 77.38,
    y2: 377.92,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.54,
    y1: 392.81,
    x2: 68.74,
    y2: 403.09,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.4,
    y1: 396.46,
    x2: 90.16,
    y2: 382.3,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.83,
    y1: 395.2,
    x2: 80.98,
    y2: 404.47,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.1,
    y1: 399.04,
    x2: 91.43,
    y2: 406.44,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 102.65,
    y1: 401.17,
    x2: 100.72,
    y2: 393.08,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.78,
    y1: 402.47,
    x2: 97.4,
    y2: 410.5,
    style: {
      fill: "none",
      stroke: "#F8FF35",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.25197px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-2--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100.16,
    y: 235.72,
    width: 304.11,
    height: 197.97,
    rx: 8.55,
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.16,
    y: 257.87,
    width: 277.82,
    height: 153.67,
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.58,
    y: 257.87,
    width: 221.4,
    height: 153.67,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.58,
    cy: 334.71,
    r: 15.16,
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128.58,
    cy: 334.71,
    r: 8.18,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 265.77,
    width: 14.15,
    height: 9.1,
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 279.42,
    width: 14.15,
    height: 9.1,
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 293.06,
    width: 14.15,
    height: 9.1,
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 306.71,
    width: 14.15,
    height: 9.1,
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 354.84,
    width: 14.15,
    height: 9.1,
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 368.48,
    width: 14.15,
    height: 9.1,
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 382.13,
    width: 14.15,
    height: 9.1,
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.2,
    y: 395.78,
    width: 14.15,
    height: 9.1,
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-1--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 217.35,
    y: 422.24,
    width: 1.68,
    height: 5.62,
    rx: 0.34,
    transform: "translate(488.52 31.11) rotate(61.63)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.15,321.76l.86-.44c5.49-3,8.92-7.29,7.64-9.65s-6.76-1.86-12.26,1.1l-.83.48Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.5,420.53c4.29-2.78,13.32-9.5,23.75-15.37S358.42,359,358.42,359l63.22-36.67s.84-.63-1.2-5l.07,0c-.24-.45-.48-.88-.71-1.27s-.42-.83-.67-1.29l-.07,0c-2.57-4.13-3.56-3.77-3.56-3.77l-65.34,32.75s-74.11,39.55-84.74,45.06-21.21,9.37-25.88,11.44a16.28,16.28,0,0,0-2.68,1.45l-18.75,21.65.55,1,.22.42.55,1,28.39-3.8A21.23,21.23,0,0,0,250.5,420.53Z",
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.03 406.09 218.11 423.33 218.66 424.34 218.88 424.76 219.43 425.77 242.45 422.69 233.03 406.09",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.6,
    y: 361.34,
    width: 7.77,
    height: 56.85,
    rx: 1.56,
    transform: "translate(491.75 -44.87) rotate(61.63)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.46,
    y: 374.73,
    width: 5.9,
    height: 37.85,
    rx: 1.18,
    transform: "translate(491.47 -36.6) rotate(61.63)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.82,
    y1: 394.1,
    x2: 272.28,
    y2: 398.66,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.58,365.49,358.42,359l63.22-36.67s.84-.63-1.2-5l.07,0c-.24-.45-.48-.88-.71-1.27s-.42-.83-.67-1.29l-.07,0c-2.57-4.13-3.56-3.77-3.56-3.77l-65.34,32.75-11.9,6.35Z",
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.65 424.13 226.18 414.01 225.16 415.19 230.1 424.34 231.65 424.13",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234 404.98 232.64 406.55 241.43 422.83 243.49 422.55 234 404.98",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 201.27,
    y: 93.21,
    width: 117.17,
    height: 77.55,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.97,
    y: 96.45,
    width: 77.47,
    height: 14.91,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.97 111.36 240.97 96.45 201.26 96.45 201.26 170.76 318.44 170.76 318.44 111.36 240.97 111.36",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.18,
    y: 137.19,
    width: 13.67,
    height: 12.26,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.82,
    y: 137.19,
    width: 13.67,
    height: 12.26,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.82,
    y: 137.19,
    width: 13.67,
    height: 12.26,
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.04,
    y: 137.19,
    width: 13.67,
    height: 12.26,
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.39,
    y: 137.19,
    width: 13.67,
    height: 12.26,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.39,
    y: 137.19,
    width: 13.67,
    height: 12.26,
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.61,
    y: 137.19,
    width: 13.67,
    height: 12.26,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.61,
    y: 137.19,
    width: 13.67,
    height: 12.26,
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.18,
    y: 150.3,
    width: 13.58,
    height: 13,
    style: {
      fill: "#F8FF35"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-7)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 282.18,
    y: 150.3,
    width: 13.58,
    height: 13,
    style: {
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 267.35,
    y: 150.3,
    width: 13.58,
    height: 13,
    style: {
      fill: "#F8FF35"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.35,
    y: 150.3,
    width: 13.58,
    height: 13,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.52,
    y: 150.3,
    width: 13.58,
    height: 13,
    style: {
      fill: "#F8FF35"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.7,
    y: 150.3,
    width: 13.58,
    height: 13,
    style: {
      fill: "#F8FF35"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.7,
    y: 150.3,
    width: 13.58,
    height: 13,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.88,
    y: 150.3,
    width: 13.58,
    height: 13,
    style: {
      fill: "#F8FF35"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.88,
    y: 150.3,
    width: 13.58,
    height: 13,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.05,
    y: 150.3,
    width: 13.58,
    height: 13,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.93,
    y: 150.3,
    width: 13.58,
    height: 13,
    style: {
      fill: "#F8FF35"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.93,
    y: 150.3,
    width: 13.58,
    height: 13,
    style: {
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.35,
    y: 118.66,
    width: 9.17,
    height: 8.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.08,
    y: 113.71,
    width: 9.17,
    height: 8.78,
    style: {
      fill: "#F8FF35"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.08,
    y: 113.71,
    width: 9.17,
    height: 8.78,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 209.52,
    y1: 104.23,
    x2: 233.19,
    y2: 104.23,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.2 100.02 297.2 100.8 298.82 102.17 297.2 103.54 297.2 104.33 299.75 102.17 297.2 100.02",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300 100.02 300 100.8 301.62 102.17 300 103.54 300 104.33 302.56 102.17 300 100.02",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 305.8,
    y1: 98.72,
    x2: 305.8,
    y2: 106.17,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.04,
    y1: 100.99,
    x2: 314.87,
    y2: 100.99,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.04,
    y1: 102.28,
    x2: 314.87,
    y2: 102.28,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.04,
    y1: 103.58,
    x2: 314.87,
    y2: 103.58,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 309.04,
    y1: 104.88,
    x2: 314.87,
    y2: 104.88,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.14,100.08s-4.09-4.47-5.58-4.47-25,3.35-26.08,2.79-1.3-4.47-3-5.21a9.84,9.84,0,0,0-3.54-.75S314.59,91,313.28,91a3.6,3.6,0,0,0-1.86.37,1.81,1.81,0,0,0,0,1.49c.37.75-.19,2.8-.19,2.8a13,13,0,0,0-3.72-.75,1.23,1.23,0,0,0-1.12,2c.56.37,3.17-.74,3.91.56s1.49,3.17,3.36,3.73a65.31,65.31,0,0,0,8.19.93L344,104.55l3.35,4.47,7.82-3.54Z",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.12,153.72l-3,3.91s-31,8.26-31.75,8.26-5.5-4-6.8-3.6-3.54,2.42-5.78,2.79-1.86,1.49-.55,1.87,3.53-.75,4.09-.75a18.22,18.22,0,0,1,2.24.37s-3.73,4.48-4.29,4.66-1.86,2.24-.93,2.24,1.12-.19,3-.19a14.84,14.84,0,0,0,3.73-.56,34.36,34.36,0,0,0,3.35-1.3c1.12-.56,33.9-3.36,35-3.36a6.17,6.17,0,0,0,4.1-2c1.11-1.31,7.82-11,7.82-11Z",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.2,226.55a69.63,69.63,0,0,1-6.7,6.15c-3.17,2.42-6.52,4.1-4.29,5.4s10.25-1.68,12.85-3.91,1.31-9.13,1.31-9.13Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.22,177.75s3,0,3,2.24-2.61,4.28-2.42,6.33.56,4.66-1.12,6.52-5.4,5.77-5.21,2.61,1.86-6.9,1.67-9.13a9.76,9.76,0,0,0-1.67-4.29l2.6-4.84Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.7,136.77c-2.61-4.65-8.57-7.82-8.57-7.82s-2.05,8.38-6.33,11a41.15,41.15,0,0,1-8.76,3.91s-6.14,1.86-14,8.94-19,22-17.32,23.66,6,1.3,13,1.86a113.65,113.65,0,0,0,13.6.56s-.75,12.48-.75,16.95-.74,32-.74,32,2.23,1.86,5.77-.19c0,0,8.2-28.13,8.2-33v-9.31s12.85-24.4,15.83-30.55S413.31,141.43,410.7,136.77ZM385,172.35l-9.88-3.54,15.65-9.5Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.92,132.78l-14.39,23.06,14.93,1.44,10.62-13.21s9.76-1.14,12.34-.86,2.17,1.79,2.87,2.3c1.31,1,2.3,1.43,8.9.57s9.18-9.47,8.32-14.35-5.45-7.46-10.33-10.91-16.36-8.89-20.67-10-12.92-2.3-12.92-2.3l-3.15-8.61s-8.61-2.3-12.06,1.43l-.57,2,12.34,24.12Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.62,119.06s1.23-8.61-3.89-14.14-16.6-1.23-19.26,3.49.21,10.85,1.23,11.88,1.23,2,0,4.09-1.64,2.26-.41,2.87a10.74,10.74,0,0,0,2,.82s3.69,4.51,4.71,6.15a3.12,3.12,0,0,0,4.3,1c1.23-.82,7-5.94,7-5.94l8.6,3.48a21,21,0,0,0,0-6.76C359.31,122.54,358.28,119.06,355.62,119.06Z",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-7)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M356.29,119.15a2.41,2.41,0,0,0-.67-.09s1.23-8.61-3.89-14.14c-4.8-5.18-15.16-1.73-18.65,2.59.71-.73,2.1-1.48,4.51-.33,3.89,1.84,2.87,3.48,3.28,6.14s4.71.82,4.92,2.26-.41,3.48,1,3.07,3.28-2.25,4.51-.21A3.45,3.45,0,0,0,356.29,119.15Z",
    style: {
      fill: "#b2b2b2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M355.62,119.06s1.23-8.61-3.89-14.14-16.6-1.23-19.26,3.49.21,10.85,1.23,11.88,1.23,2,0,4.09-1.64,2.26-.41,2.87a10.74,10.74,0,0,0,2,.82s3.69,4.51,4.71,6.15a3.12,3.12,0,0,0,4.3,1c1.23-.82,7-5.94,7-5.94l8.6,3.48a21,21,0,0,0,0-6.76C359.31,122.54,358.28,119.06,355.62,119.06Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.82,128.69A3.34,3.34,0,0,0,342.3,126",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.83,119.24s1.46-5.51,3.1-3,2.26,5.33.41,6.56-2.66.82-2.66.82",
    style: {
      fill: "#d9d9d9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.08,120.36c.2.79.07,1.49-.29,1.58s-.8-.47-1-1.26-.06-1.49.29-1.58S337.89,119.58,338.08,120.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.17,118.3s0-1.43,2.18-.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.62,119.06a11.48,11.48,0,0,1,2,6.36c0,3.73-.29,7.46.86,8.32l1.14.86s3.45-1.72,2.3-8.61S356.81,116.14,355.62,119.06Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.77,159.31s-1.86-6.52-3.35-8.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.39,178.87a19.26,19.26,0,0,1,2.61-6.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.08,
    y1: 144.07,
    x2: 376.61,
    y2: 137.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 371.96,
    y1: 143.11,
    x2: 383.51,
    y2: 136.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.42,336.47l7.05,12.16s-3.3,3.75-6.15,4.95-2.1,2.1-1.35,2.1,1.95,1.05,4.95-.15,4.8-2.4,6.15-2.25,3.75,0,3.75-1.95-.15-2.25-3.15-7.35-7.95-19.21-7.95-19.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,349.08a3.77,3.77,0,0,1-2.55-.45s-3.3,3.75-6.15,4.95-2.1,2.1-1.35,2.1,1.95,1.05,4.95-.15,4.8-2.4,6.15-2.25,3.75,0,3.75-1.95c0-1.53-.09-2.06-1.59-4.68C341.38,347.52,339.93,348.88,339,349.08Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.72,324.77l-3.3,11.7,3.33,5.75c1.31-.14,3.18-.82,5.69-2.78C335.7,333.26,332.72,324.77,332.72,324.77Z",
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.65,265.49c-2-2.25-9.16-2.7-9.16-2.7s-11.25-17.56-13.8-20.41-8.56-7.65-12.16-12.3-6.6-9.61-10.2-10.21-11.26,1.35-12.61,1.35-1.8-6.75-1.8-6.75l-7.05,3.6s1.05,4.35,0,5.25-9.76,1.05-12.16,3.46-9.45,11.85-12,14.4-10.06,7.2-12.46,9.76-11.85,11.25-14.1,12.45-4.81-1.2-6.91-1.35-5.7-.75-5.55.15,2.85,1.5,3.6,1.95,2.4,1.8,2.4,1.8-3.9-.15-4.5.15.6,1.5,1.65,1.5,1.8-.45,3.75.45,6-.3,7.21-1.2,25.06-14.7,26.71-16.2,11.85-9,11.85-9,2.85,7.36,3.75,10.21.91,12.45.15,16.65a54.88,54.88,0,0,0-.3,10.66s-8.4,18.46-9.45,24.61,1.5,8.85,1.8,9.9,9.46,14,9.46,14l.9,1.8s-.75,15-2.1,21.91a59.75,59.75,0,0,1-2.56,8.85,47.41,47.41,0,0,1-5.1,9.16c-1.2,1.35-2.4,2.4-.9,2.4s7.2-1.8,9.31-3.45a61.25,61.25,0,0,0,5.4-5.41c.9-.9.75-1.95-.15-3.3s-1.05-4.2-1.05-4.95,6.45-22.51,8.25-29.26.9-14.56.9-15,17.26-20.11,17.56-27.46-2.85-14.71-5.25-19.06-6.16-9.75-6.16-10.2,0-.15.75-3.6,4.66-18.31,4.66-18.31l6.15,3.75L371,252.89l12,11.25a12.62,12.62,0,0,0,1.65,3,19.49,19.49,0,0,0,4.95,2.55c.45,0,1.65-.15.9-.75a24,24,0,0,0-2.85-1.65s3-.15,4.05.75a12.16,12.16,0,0,0,4.06,1.95C396.2,270,395.6,267.74,393.65,265.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.44,267.28c-.05.43-.11.85-.18,1.21a54.88,54.88,0,0,0-.3,10.66s-8.4,18.46-9.45,24.61,1.5,8.85,1.8,9.9,9.46,14,9.46,14l.9,1.8s-.41,8.13-1.17,15.18a9.84,9.84,0,0,0,6.7.32c2-6.94,4.54-15.69,5.57-19.55,1.8-6.76.9-14.56.9-15s17.26-20.11,17.56-27.46c.24-6-1.79-11.95-3.85-16.31C342.76,268,330.22,270.34,320.44,267.28Z",
    style: {
      fill: "gray",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.67,329.42s.75-18.61,1.05-21.61,12.75-26.26,12.75-26.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 333.47,
    y1: 286.95,
    x2: 328.52,
    y2: 281.55,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.69,242.38c-2.55-2.85-8.56-7.65-12.16-12.3s-6.6-9.61-10.2-10.21c-2.44-.4-6.71.35-9.65.89-1,3.31-3.43,9.82-8.21,10.82-5.35,1.12-6.37-5.29-6.56-7.52-3.07.5-7.57,1.09-9.2,2.72-2.4,2.4-9.45,11.85-12,14.4s-10.06,7.2-12.46,9.76c-1.24,1.32-4.37,4.28-7.41,7a10.32,10.32,0,0,0,3.23,3.94c7.46-4.42,17.39-10.29,18.44-11.24,1.65-1.5,11.85-9,11.85-9s2.85,7.36,3.75,10.21.91,12.45.15,16.65a33,33,0,0,0-.4,4.59c12.32,4.11,25.73-1,30.05-2.87a50.61,50.61,0,0,0-2.93-6.37c-2.4-4.35-6.16-9.75-6.16-10.2s0-.15.75-3.6,4.66-18.31,4.66-18.31l6.15,3.75L371,252.89l1.44,1.35,4.36-3.24C374.21,247.14,371.73,243.54,370.69,242.38Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.36,241.63a26.36,26.36,0,0,1-.15-3.3,14.74,14.74,0,0,1,1.2-5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.33,190.31a6.76,6.76,0,1,1-6.76-6.75A6.76,6.76,0,0,1,345.33,190.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.52,185.81a.49.49,0,0,1-.28-.09.47.47,0,0,1-.08-.64c.13-.17,3.28-4.13,9.95-2a.46.46,0,0,1,.3.57.47.47,0,0,1-.57.29c-6.06-2-8.84,1.5-9,1.65A.46.46,0,0,1,334.52,185.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.29,202.3s.65-8-4.34-11.71-11.92-1.52-14.74,3.69-.87,10.18,0,13.65,1.73,6.07,3.47,8.24,5,3.9,7.58,3.25,5-5,6.29-9.75c0,0,2.17.21,3.69-2.39S340.89,200.35,338.29,202.3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325,205.92a1.37,1.37,0,0,1,0,1.73c-.67,1.06-1.47,2-.8,2.39a4.9,4.9,0,0,0,1.59.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1141201257705688px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.63,213.45c.29.38,3.41,1.57,4.56-1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1141201257705688px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 329.19,
    cy: 205.39,
    rx: 0.68,
    ry: 1.58,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.19,205.73c0,.87-.22,1.59-.6,1.61s-.71-.67-.75-1.54.22-1.59.6-1.61S323.15,204.86,323.19,205.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,202.12s2.55-1.51,4.05.45",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.42,203.17s-1.95-1.66-3.46,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.31,201.79c0-1.8-.12-8.06-4.36-11.2-5-3.69-11.92-1.52-14.74,3.69a12,12,0,0,0-1.44,5v1.07s-.06-5.9,4.9-7,8.81.69,9.9,3.23c1.21,2.83,1.5,4,2.17,5.49s1.47,3.64,2.22,2.74C337.29,204.44,337.88,202.43,338.31,201.79Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.72,362.88c.9-.9.75-1.95-.15-3.3a4.5,4.5,0,0,1-.52-1.17l-2.93,3.42a15.13,15.13,0,0,0-2.1-3.15c-1.51-1.8-2.41.15-2.41.15l-.08,0c-.18.44-.35.87-.52,1.32a47.41,47.41,0,0,1-5.1,9.16c-1.2,1.35-2.4,2.4-.9,2.4s7.2-1.8,9.31-3.45A61.25,61.25,0,0,0,326.72,362.88Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.38,205.85l-7,26.45s-7.56.3-9,.74-2.52,4-2.37,4.74,1,.45,1.78.15c0,0-1.93.89-.59,1.19s4.74-1,4.74-1,5.78,0,6.67-1a18.81,18.81,0,0,0,2.66-5.48c.3-1.33,11-22.75,11-22.75S132.75,209,130.38,205.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.79,237.93a23.35,23.35,0,0,1,5.48-2.37",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.25 208.6 180.95 224.75 186.14 224.75 181.1 204.75 173.25 208.6",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.88,293.8s-1.19,9-.6,9,7.56,2.22,9,2.66,8.45,1.63,8.89.89-9.92-8.3-10.37-8.74a17.94,17.94,0,0,1-1.48-2.82Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.57,267.27s-5,5-4.09,6,9.75,13.21,12,12-2.83-13.85-2.83-13.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203,225.93c-10.52-4.89-27.56-4-27.56-4L172.36,216a46.1,46.1,0,0,1-9.93,2.52c-5,.59-17.19-1.34-17.19-1.34S143,228.45,143,232.75s2.82,4.45,14.52,7.11,23.56,4,23.56,4-1.78,15.71-1.48,25.93-.74,24-.74,24l5.48,1L191.81,269s24.7-27.06,27.22-28.69S213.55,230.82,203,225.93Zm-8,25.34s.89-8.59.89-10.07-1.78-3.26-1.78-3.26c1.18.44,7.56,2.22,7.56,2.22Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.14,237.94a40.34,40.34,0,0,0-25-10.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.03,
    y1: 251.27,
    x2: 191.81,
    y2: 269,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.94,228.75s5.53-3.38,11.37-2.15",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.58,163.55a71.2,71.2,0,0,1-11,6.23c-6.22,2.81-12,5.48-12,6.52s-3.89,25.85-3.89,26.29,1.62,3.11,3.85,3.11a11.4,11.4,0,0,0,3.11-.29l4.64-9.41s2.22,20.75,1.92,21.19,2.82,3.26,5.63,4,21.78-1.63,22.38-3.7S170.43,203,170.43,203l.89-7,1.48,8.6s-.15,1.18,2.67.74a5.81,5.81,0,0,0,4-2.52s-.3-16.74-.3-20.89,1.93-6.67.45-7.71-14.67-9.63-16-10.52A6,6,0,0,0,158.58,163.55Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.72,200.07a6.84,6.84,0,0,0,3.11,2.82c2.22,1,4.29-.15,4.89.59s.79,4.69-1.19,5.78a6.58,6.58,0,0,1-7-.45c-2.14-1.35-2.08-2.22-1.93-3.4S130.23,200.07,131.72,200.07Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.77,204.3s1,3.85,1.48,4.3,4.74.29,7.85-2.52a3,3,0,0,0,0-1.33c-.15-.89-1.19-4-1.63-4s-4,3-6.67,2.23C172.8,203,171.17,202.82,171.77,204.3Z",
    style: {
      fill: "#F8FF35",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.32,
    y1: 196,
    x2: 174.25,
    y2: 183.44,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.32,196s2.43-7.36,2.43-9.17-2-5.2-2-5.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.36,155.4l-3.56,10.08s4.89,13.19,5.48,13,6.52-12.6,6.52-12.6-1.48-8.44-3-12S160.36,155.4,160.36,155.4Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.28,138.81s4.45,3.11,4.89,4.44-1.18,3-1.18,3,.15,5,.15,6.22A4.78,4.78,0,0,1,177,155s2.22,3.26,1.63,4a3.06,3.06,0,0,1-1.78.89s-.29,3-.89,3.7l-.59.74a25.83,25.83,0,0,1-.15,4.6c-.29,1-2.07,1.78-5.48-.15s-5.63-3.56-6.07-5a28.19,28.19,0,0,1-.45-5.33l-1.48-4.3-1.63,3a25.05,25.05,0,0,1-3.85-11c-.89-7,7.26-9.48,11-9.78S174.28,138.81,174.28,138.81Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.17,143.25c-.44-1.33-4.89-4.44-4.89-4.44s-3.4-2.82-7.11-2.52-11.85,2.81-11,9.78a25.05,25.05,0,0,0,3.85,11l1.63-3,1.48,4.3a28.19,28.19,0,0,0,.45,5.33c.44,1.48,2.66,3.11,6.07,5s5.19,1.18,5.48.15a19.22,19.22,0,0,0,.17-3.84s0,0,0,0c-1.48-.44-2.22,2.08-3.55,1.63s-5.19-3-6.08-5.48-.74-9.48-.74-9.48a25.67,25.67,0,0,0,4.3-2.08c.89-.74-1.34-2.66-2.67-3.7s1-2.07,4.59-2.37,6.82,2.67,6.82,2.67S179.62,144.59,179.17,143.25Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.76,156.59s-.29-4.89-2.07-5.19-2.22,3.71-1.63,5.63,2.81,1.78,3.11,1.34A7.86,7.86,0,0,0,163.76,156.59Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.8,159.85s-4.29.3-5.92.3-2.08.74-.89,2.07a6.34,6.34,0,0,0,4.44,1.63c.6-.15,1.48-.3,1.48-.3S178,161.77,176.8,159.85Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.77,
    cy: 155.4,
    rx: 0.67,
    ry: 1.19,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.47,152.88s-.44-2.07-3.41-1.33",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignCommunityBro);
export default __webpack_public_path__ + "static/media/Design-community-bro.c1ae4646c0a063247899cb038d485294.svg";
export { ForwardRef as ReactComponent };